import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import 'react';
import { BoldHeading } from '@lendi-jam/atoms';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleButtonTrackingEvent, handleLinkTrackingEvent } from '@lendi-jam/tracking';
import { Button } from '@lendi-ui/button';
import Grid, { Grid as Grid$1 } from '@lendi-ui/grid';
import { Body, link } from '@lendi-ui/typography';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte } from '@lendi-ui/breakpoint';
import { color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { pt, pb, p, ml } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var TextLayoutContainer = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), pt('xxxl'), pb('xxxl'));
var TextLayoutBackground = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (_ref) {
  var variant = _ref.variant;
  switch (variant) {
    case 'mint':
      return color('primary.50');
    case 'grey':
      return color('shade.50');
    default:
      return color('shade.0');
  }
});
var LeftGridUnit = styled(Grid.Unit)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n  border-color: ", ";\n  ", "\n\n  ", ";\n"])), function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'two' ? "1px solid" : 'initial';
}, color('shade.800'), function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'two' ? pb('xxl') : '';
}, gte('lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        border-bottom: initial;\n        ", "\n    "])), pb('nil')));
var RightGridUnit = styled(Grid.Unit)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'two' ? pt('xl') : '';
}, gte('lg')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n     ", "\n"])), pt('nil')));
var RightContentContainer = styled(Body)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  & > p {\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n"])));
var LayoutLink = styled.a(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: none;\n  display: inline-block;\n  vertical-align: sub;\n  line-height: 1;\n  ", "\n  ", "\n"])), link({
  size: 'xs'
}), color('primary.500'), p('xxs'), ml('sm'));

var TextLayout = function TextLayout(_ref) {
  var title = _ref.title,
    leftSection = _ref.leftSection,
    rightSection = _ref.rightSection,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'white' : _ref$variant,
    _ref$layoutVariant = _ref.layoutVariant,
    layoutVariant = _ref$layoutVariant === void 0 ? 'two' : _ref$layoutVariant;
  return /*#__PURE__*/jsx(TextLayoutBackground, {
    variant: variant,
    children: /*#__PURE__*/jsxs(TextLayoutContainer, {
      children: [title && /*#__PURE__*/jsx(BoldHeading, {
        mb: "lg",
        size: "lg",
        children: title
      }), /*#__PURE__*/jsxs(Grid$1, {
        children: [/*#__PURE__*/jsxs(LeftGridUnit, {
          variant: layoutVariant,
          size: {
            lg: layoutVariant === 'two' ? 1 / 2 : 5 / 12
          },
          children: [leftSection.title && /*#__PURE__*/jsx(BoldHeading, {
            size: layoutVariant === 'two' ? 'md' : 'lg',
            mb: layoutVariant === 'two' ? 'md' : 'lg',
            children: leftSection.title
          }), leftSection.content && /*#__PURE__*/jsx(Body, {
            mb: "lg",
            children: leftSection.content
          }), leftSection.primaryButton && leftSection.primaryButton.text && /*#__PURE__*/jsx(Button, {
            variant: "primary",
            size: "xs",
            href: embedMarketingTrackingIntoURL(leftSection.primaryButton.url),
            onClick: function onClick() {
              var _leftSection$primaryB;
              handleButtonTrackingEvent(_objectSpread(_objectSpread({}, leftSection.primaryButton), {}, {
                text: (_leftSection$primaryB = leftSection.primaryButton) === null || _leftSection$primaryB === void 0 ? void 0 : _leftSection$primaryB.text,
                variant: 'primary'
              }));
            },
            children: leftSection.primaryButton.text
          }), leftSection.secondaryButton && leftSection.secondaryButton.text && /*#__PURE__*/jsx(LayoutLink, {
            href: embedMarketingTrackingIntoURL(leftSection.secondaryButton.url),
            onClick: function onClick() {
              var _leftSection$secondar;
              handleLinkTrackingEvent((_leftSection$secondar = leftSection.secondaryButton) === null || _leftSection$secondar === void 0 ? void 0 : _leftSection$secondar.url);
            },
            children: leftSection.secondaryButton.text
          })]
        }), /*#__PURE__*/jsxs(RightGridUnit, {
          variant: layoutVariant,
          size: {
            lg: layoutVariant === 'two' ? 1 / 2 : 7 / 12
          },
          children: [rightSection.title && /*#__PURE__*/jsx(BoldHeading, {
            size: "md",
            mb: "md",
            children: rightSection.title
          }), /*#__PURE__*/jsx(RightContentContainer, {
            mb: "lg",
            children: rightSection.content
          }), rightSection.primaryButton && rightSection.primaryButton.text && /*#__PURE__*/jsx(Button, {
            variant: "primary",
            size: "xs",
            href: embedMarketingTrackingIntoURL(rightSection.primaryButton.url),
            onClick: function onClick() {
              var _rightSection$primary;
              handleButtonTrackingEvent(_objectSpread(_objectSpread({}, rightSection.primaryButton), {}, {
                text: (_rightSection$primary = rightSection.primaryButton) === null || _rightSection$primary === void 0 ? void 0 : _rightSection$primary.text,
                variant: 'primary'
              }));
            },
            children: rightSection.primaryButton.text
          }), rightSection.secondaryButton && rightSection.secondaryButton.text && /*#__PURE__*/jsx(LayoutLink, {
            href: embedMarketingTrackingIntoURL(rightSection.secondaryButton.url),
            onClick: function onClick() {
              var _rightSection$seconda;
              handleLinkTrackingEvent((_rightSection$seconda = rightSection.secondaryButton) === null || _rightSection$seconda === void 0 ? void 0 : _rightSection$seconda.url);
            },
            children: rightSection.secondaryButton.text
          })]
        })]
      })]
    })
  });
};

export { TextLayout as default };
